import { useEffect, useState } from 'react';
import css from './AddNewStaff.module.css';
import toShort from '../../../../../services/utils/dateParser';

import AddEditForm from '../../../_common/elements/forms/AddEditForm';
import FormData from '../../../_common/elements/forms/FormData';
import FormComment from '../../../_common/elements/forms/FormComent';
import FormButtons from '../../../_common/elements/forms/FormButtons';
import * as staffServices from '../../../../../services/staffServices'

function AddNewStaff({ data, toggleModal, staffData, func = 'add' }) {
    const [message, setMessage] = useState({ message: '', color: 'black' }); //check why colors are not changing
    const [nextStaffNo, setNextStaffNo] = useState('');

    useEffect(() => {
        if (data) {
            const nextNo = () => {
                let current = data.sort((a, b) => b.No.localeCompare(a.No))[0].No;

                let next = Number(current.slice(1)) + 1;
                next = 'A' + String(next).padStart(3, '0');
                setNextStaffNo((state) => next);
                setNewData((state) => ({ ...state, staffNo: nextStaffNo }));
            };
            nextNo();
        }
    }, [data, nextStaffNo]);
    
    let template = {
        staffNo: staffData?.staffNo || nextStaffNo,
        staffName: staffData?.staffName || '',
        staffDoB: (staffData && toShort(staffData.staffDoB, 1)) || '',
        staffEmail: staffData?.staffEmail || '',
        staffPhone: staffData?.staffPhone || '',
        staffNotes: staffData?.staffNotes || '',
    };

    const [newData, setNewData] = useState(template);

    // console.log(newData);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setNewData((state) => ({
            ...state,
            [id]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        staffServices
            .create(newData)
            .then((result) => {
                console.log(result);
                setNewData((prevDate) => template);
                setMessage((state) => ({ message: result.message, color: 'green' })); //check why colors are not changing
                return true;
            })
            .catch((err) => {
                // console.log(err);
                setMessage((state) => ({ message: 'Sorry, something went wrong!', color: 'red' })); //check why colors are not changing
                console.log(message); //check why colors are not changing
                return false;
            });
    };

    const onAddStay = (e) => {
        handleSubmit(e);
        setNewData((state) => template);
    };

    const onAddClose = (e) => {
        let pass = handleSubmit(e);
        if (pass) {
            toggleModal();
        }
    };

    const onEdit = (e) => {
        e.preventDefault();
        console.log(newData);
        const updateData = newData;
        updateData._id = staffData.staffId;
        console.log(updateData);

        staffServices
            .edit(updateData)
            .then((res) => {
                setMessage({
                    message: `${updateData.staffName} is updated successfully!`,
                    color: 'green',
                });
                toggleModal();
            })
            .catch((err) => {
                setMessage({ message: err.message || 'Unknown error ...', color: 'red' });
            });
    };

    return (
        <AddEditForm>
            <FormData>
                <label className={css.label} htmlFor="staffNo">
                    Staff ID:{' '}
                </label>
                <input className={css.input} type="text" id="staffNo" value={newData.staffNo} onChange={handleChange} disabled />

                <label className={css.label} htmlFor="staffName">
                    First Name:{' '}
                </label>
                <input className={css.input} type="text" id="staffName" value={newData.staffName} onChange={handleChange} />

                <label className={css.label} htmlFor="staffDoB">
                    Date of birth:{' '}
                </label>
                <input className={css.input} type="date" id="staffDoB" value={newData.staffDoB} onChange={handleChange} />

                <label className={css.label} htmlFor="staffEmail">
                    Email:{' '}
                </label>
                <input className={css.input} type="mail" id="staffEmail" value={newData.staffEmail} onChange={handleChange} />

                <label className={css.label} htmlFor="staffPhone">
                    Phone:{' '}
                </label>
                <input className={css.input} type="text" id="staffPhone" value={newData.staffPhone} onChange={handleChange} />
            </FormData>
            <FormComment>
                <label htmlFor="staffNotes">Notes</label>
                <textarea id="staffNotes" className={css.textarea} rows="32" onChange={handleChange} value={newData.staffNotes}>
                    {/* {newData.staffNotes} */}
                </textarea>
            </FormComment>
            <FormButtons>
                {func === 'add' && (
                    <div className={css.submitButtons}>
                        <button className={css.greenButton} onClick={onAddStay}>
                            Add Staff and stay
                        </button>
                        <button className={css.greenButton} onClick={onAddClose}>
                            Add Staff and close
                        </button>
                    </div>
                )}
                {func === 'edit' && (
                    <div className={css.submitButtons}>
                        <button className={css.orangeButton} onClick={onEdit}>
                            Edit Staff
                        </button>
                    </div>
                )}
                <button onClick={toggleModal} className={`${css.redButton} ${css.buttonClose}`}>
                    Cancel
                </button>
            </FormButtons>
            <p className={css[message.color]}>{message.message}</p>
        </AddEditForm>
    );
}

export default AddNewStaff;
